var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgConfirm = function SvgConfirm(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 21.3 19.8",
    style: {
      enableBackground: "new 0 0 21.3 19.8"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.6,13.3l-2.6-0.7c-2.5-0.7-4-3.3-3.4-5.9l0.7-2.6c0.4-1.7-0.6-3.5-2.3-4C4.4-0.1,3.7,0,3.1,0.2 C2.9,0.2,2.7,0.3,2.5,0.4l-0.1,0C1.8,0.9,1.2,1.6,1,2.4L0.4,5c-1.5,6,2.1,12.3,8,13.9l2.6,0.7c0.3,0.1,0.6,0.1,0.9,0.1 c0.6,0,1.1-0.1,1.6-0.4c0.2-0.1,0.3-0.2,0.5-0.4c0.5-0.4,0.8-1,1-1.6C15.4,15.6,14.3,13.8,12.6,13.3z M13.8,17 c-0.1,0.4-0.3,0.8-0.6,1c-0.1,0.1-0.2,0.2-0.3,0.2c-0.5,0.3-1,0.3-1.5,0.2l-2.6-0.7c-5.4-1.5-8.6-7.1-7.2-12.5l0.7-2.6 c0.1-0.5,0.5-1,0.9-1.2l0,0c0.1-0.1,0.2-0.1,0.3-0.2c0.4-0.1,0.8-0.1,1.2,0c1.1,0.3,1.8,1.5,1.5,2.6L5.5,6.4 c-0.8,3.2,1.1,6.5,4.2,7.3l2.6,0.7C13.4,14.8,14.1,15.9,13.8,17z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.2,2.1c0-0.1-0.1-0.1-0.2-0.2l-5.8-1.6c-0.1,0-0.2,0-0.3,0c-0.1,0-0.1,0.1-0.2,0.2l-0.1,0.5 c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.2,0.2L19,2.6l-7.5,4.3c-0.2,0.1-0.2,0.3-0.1,0.5l0.3,0.5c0,0.1,0.1,0.1,0.2,0.1 c0.1,0,0.2,0,0.3,0l0,0l7.5-4.3l-1.1,4.1c0,0.1,0,0.2,0,0.3c0,0.1,0.1,0.1,0.2,0.2l0.5,0.1c0.1,0,0.2,0,0.3,0s0.1-0.1,0.2-0.2 l1.5-5.8C21.3,2.2,21.3,2.2,21.2,2.1z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfirm, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confirm.e711d68d.svg";
export { ForwardRef as ReactComponent };